import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import Lottie from "react-lottie";
import Confetti from "../../../public/assets/lotties/confetti.json";
import { AgencyId } from "../../messages";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppOverlay } from "../Generic/AppOverlay";
import Flex from "../Generic/Flex";
import { withMedflytAgencyId } from "../withMedflytAgencyId";

export interface PointsConfettiProps {
  isOpen: boolean;
  pointsNumber: number;
  medflytAgencyId: AgencyId;
  onClose: () => void;
}

const fadeOut = keyframes`
    from { opacity: 1; }
    to   { opacity: 0; }
`;

const fadeIn = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;

const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: Confetti,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const audioSrc = "/public/assets/confetti_audio.mp3";

function PointsConfetti(props: PointsConfettiProps) {
  React.useEffect(() => {
    const timeId = setTimeout(() => {
      props.onClose();
    }, 2000);

    return () => {
      clearTimeout(timeId);
    };
  }, [props]);

  if (!props.isOpen) {
    return null;
  }
  return (
    <PointsConfetti.Overlay>
      <PointsConfetti.Audio autoPlay={true} src={audioSrc} />
      <PointsConfetti.TextWrapper>
        <Flex direction="column">
          <PointsConfetti.PointsNumber>{`+${props.pointsNumber}`}</PointsConfetti.PointsNumber>
          <PointsConfetti.Subtitle>{translate(STRINGS.CAREBACK_POINTS)}</PointsConfetti.Subtitle>
        </Flex>
      </PointsConfetti.TextWrapper>
      <Lottie options={lottieOptions}></Lottie>
    </PointsConfetti.Overlay>
  );
}

PointsConfetti.TextWrapper = styled.div`
  z-index: 10;
  top: 40%;
  font-weight: 800;
  font-size: 64px;
  position: absolute;
  width: 100%;
  text-align: center;
  animation: ${fadeIn} 0.5s, ${fadeOut} 0.2s ease-in 1.8s;
  animation-fill-mode: forwards;
  color: white;
  text-shadow: 2px 2px 4px black;
`;

PointsConfetti.PointsNumber = styled.span`
  font-weight: 800;
  font-size: 64px;
`;

PointsConfetti.Audio = styled.audio`
  display: none;
`;

PointsConfetti.Subtitle = styled.span`
  font-weight: 600;
  font-size: 48px;
`;

PointsConfetti.Overlay = styled(AppOverlay)`
  > div > svg {
    background: rgba(40, 56, 71, 0.8);
    backdrop-filter: blur(2px);
    top: 0;
    position: fixed;
    pointer-events: none;
    z-index: 9;
  }
`;

export default withMedflytAgencyId(PointsConfetti);
